// YouTube players (<div class="video" data-id="...">): the Drupal site's script puts the
// video's cover picture and a play button in them, and swaps in the video when clicked.
// Page bodies (Body.js) and profile pages (UserProfile.js) have them.
export const addYoutubePlayers = (root) => {
    root.querySelectorAll('.player .video[data-id]').forEach((video) => {
        if (video.querySelector('div, iframe')) return;

        const cover = document.createElement('div');
        const thumb = document.createElement('img');
        thumb.src = 'https://i.ytimg.com/vi/' + video.dataset.id + '/hqdefault.jpg';
        thumb.alt = '';
        cover.append(thumb, document.createElement('span'));
        cover.onclick = () => {
            const iframe = document.createElement('iframe');
            iframe.src = 'https://www.youtube.com/embed/' + video.dataset.id + '?autoplay=1';
            iframe.allowFullscreen = true;
            iframe.allow = 'autoplay';
            iframe.frameBorder = '0';
            video.replaceChild(iframe, cover);
        };
        video.appendChild(cover);
    });
};
